import React from "react";
import { Card } from "react-bootstrap";

const CardBusinessInfo = ({ business, planName, onChangeBusinessCallback }) => {
  return (
    <Card style={{ border: "none", borderRadius: "1rem" }}>
      <Card.Body>
        <Card.Title className="text-center">
          ¡Hola{" "}
          <span className="text-primary">
            {business.razonSocial ?? business.correoEmpresarial}
          </span>
          !
        </Card.Title>
        <Card.Text className="mt-3">
          Te damos la bienvenida al proceso de compra de tu{" "}
          <b>Plan {planName}.</b>
        </Card.Text>
        <Card.Text className="mt-3">
          Para garantizar la seguridad, consistencia y efectividad de las
          transacciones de pago, hemos seleccionado Payphone como nuestra
          pasarela de pagos de confianza. En la parte inferior, encontrarás las
          opciones de formas de pago disponibles. Puedes realizar tu pago con tu
          tarjeta o utilizando la aplicación propia de Payphone.
        </Card.Text>
        <Card.Text className="mt-3">
          Te sugerimos revisar detenidamente el plan que estás a punto de
          adquirir. Si surge alguna pregunta o inquietud, no dudes en ponerte en
          contacto con nosotros a través de nuestro correo electrónico{" "}
          <em>info@blackhorse.ec</em> o llamarnos al <em>+593 99 995 4428</em>.
        </Card.Text>
        <Card.Text className="mb-5">
          Estamos aquí para ayudarte en todo momento!
        </Card.Text>

        <div className="text-center">
          <div id="pp-button" />

          <div className="mt-5">
            <span>
              Esta no es tu empresa ?{" "}
              <Card.Link
                href="#"
                onClick={() => onChangeBusinessCallback()}
                className="text-primary"
              >
                Cambiar empresa
              </Card.Link>
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CardBusinessInfo;
